import { render, staticRenderFns } from "./BasePoster.vue?vue&type=template&id=91763b66&"
import script from "./BasePoster.vue?vue&type=script&lang=js&"
export * from "./BasePoster.vue?vue&type=script&lang=js&"
import style0 from "./BasePoster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports